'use strict';

module Patersons {

    export class PortfolioGraphComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/portfolioGraph.component.html';
        controller: any = PortfolioGraphController;
        bindings: any = {
					account: '<',
        };
    }

    export class PortfolioGraphController {
			account: Account;

			portfolioService: Patersons.PortfolioService;

			assetClassOptions: any;
			assetClassData: any;
			assetClassLabels: any;
			assetClassError: boolean;

			sectorOptions: any;
			sectorsError: boolean;
			sectorData: any;
			sectorLabels: any;
			
			summaryLoaded: boolean;
			summaryError: boolean;

			activeToggle: "assetClass" | "sector";
			
			static $inject = ['$scope', 'portfolioService']; 
			constructor($scope, portfolioService){
				this.sectorOptions = {
          showLabel: false,
          donut: true,
          donutWidth: 45
        };
				this.assetClassOptions = {
          showLabel: false,
          donut: true,
          donutWidth: 45
        };
				this.portfolioService = portfolioService;
				this.activeToggle = "sector";
				this.getTopSectors();
			}

			toggleActive(toggle: "assetClass" | "sector") {
				this.activeToggle = toggle;
				this.getTopSectors();

			}

			extractSeriesData(results: Array<Sector>) {
				if (results.length == 0) {
					var emptyData = [100];
					var emptyLabels = new Array();
					emptyLabels.push({ name: "Unknown", value: 100 });
					emptyLabels.push({ name: "--", value: 0 });
					emptyLabels.push({ name: "--", value: 0 });
					emptyLabels.push({ name: "--", value: 0 });
					emptyLabels.push({ name: "--", value: 0 });

					return {
						data: emptyData,
						labels: emptyLabels
					}
				} else {

					var total: number = 0;
					for (var i = 0; i < results.length; i++) {
						total = total + results[i].count;
					}
					var seriesData: Array<number> = new Array<number>();
					var labelData = [];
	
					for (var i = 0; i < results.length; i++) {
	
						var percentage: number = (results[i].count / total) * 100;
						var roundedPercentage = Math.round(percentage * 100000) / 100000;
						seriesData.push(roundedPercentage);
	
						var label: any = {};
						label.name = results[i].sectorName;
						label.value = roundedPercentage.toFixed(2);
						labelData.push(label);
					}
					console.log
					return {
						data: seriesData,
						labels: labelData
					}
				}

			}

			getSectorDataPromise(): any {
				if (this.account.accountType === 'Standard') {
					switch (this.activeToggle) {
						case "assetClass":
							return this.portfolioService.getTopAssetClass(this.account.accountId);
						case "sector":
							return this.portfolioService.getTopSectors(this.account.accountId);
					}
				} else {
					switch (this.activeToggle) {
						case "assetClass":
							return this.portfolioService.getAccoladeTopAssetClass(this.account.accountId);
						case "sector":
							return this.portfolioService.getAccoladeTopSectors(this.account.accountId);
					}
				} 
			}

			getTopSectors() {

				if(
					this.activeToggle === "assetClass" && this.assetClassData !== undefined ||
					this.activeToggle === "sector" && this.sectorData !== undefined
				){
					return;
				}
				this.summaryLoaded = false;
				this.summaryError = false;
				let promise = this.getSectorDataPromise()
				promise.then((results: Array<Sector>) => {
					var data = this.extractSeriesData(results);
					switch (this.activeToggle) {
						case "assetClass":
							this.assetClassData = {
								series: data.data
							};
							this.assetClassLabels = data.labels;
							this.assetClassError = false;
							break;
						case "sector":
							this.sectorData = {
								series: data.data
							};
							this.sectorLabels = data.labels;
							this.sectorsError = false;
							break;
					}
					
					this.summaryError = false;
					this.summaryLoaded = true;
				},
					(reason) => { // error handling
						this.sectorsError = true;
						this.summaryError = true;
						this.summaryLoaded = true;
					});
			}
    }

}

